import { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { NotebookPen } from 'lucide-react';
import axios from 'axios';
import { API_URL } from '../config/api';
import { getToken } from '../utils/authToken';
import { useLanguage } from '../context/LanguageContext';

/**
 * Boton "Agenda Comunicativa y Ayuda" — vive al lado de la campanita de notificaciones.
 * Si el usuario es admin, muestra un badge con la cantidad de mensajes
 * pendientes (no leidos). Para usuarios normales, no hay badge.
 */
const FeedbackNotesButton = () => {
  const navigate = useNavigate();
  const { language } = useLanguage();
  const es = language === 'es';
  const [unread, setUnread] = useState(0);

  const fetchUnread = useCallback(async () => {
    try {
      const token = getToken();
      if (!token || token === 'guest') return;
      const res = await axios.get(`${API_URL}/feedback/admin/unread-count`, {
        validateStatus: (s) => s < 500,
      });
      if (res.status === 200) setUnread(res.data.unread || 0);
      else setUnread(0);
    } catch { /* silent */ }
  }, []);

  useEffect(() => {
    fetchUnread();
    const interval = setInterval(fetchUnread, 60000);
    return () => clearInterval(interval);
  }, [fetchUnread]);

  const baseTitle = es ? 'Agenda de Comunicación y Ayuda' : 'Communication & Help Agenda';
  const pendingTitle = (n) => es
    ? `Agenda de Comunicación y Ayuda — ${n} pendiente(s)`
    : `Communication & Help Agenda — ${n} pending`;

  return (
    <button
      id="notes-button"
      onClick={() => navigate('/feedback')}
      title={unread > 0 ? pendingTitle(unread) : baseTitle}
      aria-label={baseTitle}
      data-testid="feedback-notes-btn"
      className="relative p-1.5 text-slate-400 hover:text-white hover:bg-slate-700/50 rounded-lg transition-colors"
    >
      <NotebookPen className="w-4 h-4" />
      {unread > 0 && (
        <span
          className="absolute -top-0.5 -right-0.5 min-w-[16px] h-4 flex items-center justify-center text-[10px] font-bold text-white bg-amber-500 rounded-full px-1"
          data-testid="feedback-notes-badge"
        >
          {unread > 99 ? '99+' : unread}
        </span>
      )}
    </button>
  );
};

export default FeedbackNotesButton;
